import React from 'react';
import { Form, Col, Row, Card } from 'react-bootstrap';
import Moment from "moment";

function RecordHistory({
    created_date,
    created_by,
    last_edited_date,
    last_edited_by
}) {
    const formatDate = (date) => (
        date && Moment(date).isValid()
            ? Moment(date).local().format("DD-MM-YYYY") 
            : ""
    );

    const renderHistoryField = (label, value) => (
        <Form.Group as={Row} className="mb-2">
            <Form.Label className="text-right" column sm={6} md={6} lg={4}>{label}</Form.Label>
            <Col>
                <Form.Control
                    value={value || ''}
                    plaintext 
                    readOnly
                />
            </Col>
        </Form.Group>
    );

    return (
        <Card style={{ width: '28rem' }}>
            <Card.Body>
                {renderHistoryField("Created Date", formatDate(created_date))}
                {renderHistoryField("Created By", created_by)}
                {renderHistoryField("Last Edited Date", formatDate(last_edited_date))}
                {renderHistoryField("Last Edited By", last_edited_by)}
            </Card.Body>
        </Card>
    );
}

export default RecordHistory;